import axios from "axios";

//https://api.moneybreeze.md/
//https://apibreeze.amark.pro/
let urlAPI = "https://api.moneybreeze.md/";
let axiosInstance = axios.create({
  baseURL: urlAPI,
  headers: {
    Authorization: `Bearer ${window.localStorage.getItem("token")}`,
  },
});

export { urlAPI, axiosInstance };
